<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiCodeBraces } from "@mdi/js";
export default {
  name: "MdiCog",
  data() {
    return {
      svgPath: mdiCodeBraces,
    };
  },
};
</script>
